"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Assertable {
    static assert(condition, message = '') {
        if (!condition) {
            message = message || "Assertion failed";
            if (typeof Error !== "undefined") {
                throw new Error(message);
            }
            throw message;
        }
    }
}
exports.Assertable = Assertable;
//# sourceMappingURL=assertable.js.map